import React from 'react';
import { MarketBiddingTypes } from 'interfaces/market';
import Api from '../api';

interface getMarketBiddingsParams {
  setMarketBiddingsLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketBiddings: React.Dispatch<React.SetStateAction<MarketBiddingTypes[]>>;
  organ_id: number;
}

export const getMarketBiddings = async (params: getMarketBiddingsParams) => {
  const { setMarketBiddingsLoaded, setMarketBiddings, organ_id } = params;

  const response = await Api.get(`/mercado/get_biddings.json?orgao_id=${organ_id}`);

  if (response?.status !== 200) return;

  setMarketBiddingsLoaded(true);
  setMarketBiddings(response?.data?.licitacoes);
};
